export const TRANSITIONS = {
    'Fade': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Fade/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Fade/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Fade/vertical.json',
        },
        'transitionDuration': 200,
    },
    'FadeSlow': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/FadeSlow/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/FadeSlow/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/FadeSlow/vertical.json',
        },
        'transitionDuration': 600,
    },
    'Erase left': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/EraseLeft/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/EraseLeft/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/EraseLeft/vertical.json',
        },
        'transitionDuration': 200,
    },
    'Erase down': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'Slide left': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SlideLeft/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SlideLeft/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SlideLeft/vertical.json',
        },
        'transitionDuration': 200,
    },
    'Slide down': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SlideDown/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SlideDown/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SlideDown/vertical.json',
        },
        'transitionDuration': 200,
    },
    'Circle': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'CircleSlow': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/CircleSlow/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/CircleSlow/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/CircleSlow/vertical.json',
        },
        'transitionDuration': 1000,
    },
    'CircleRight': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/CircleRight/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/CircleRight/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/CircleRight/vertical.json',
        },
        'transitionDuration': 1000,
    },
    'CircleDown': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'SkewedRight': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SkewedRight/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SkewedRight/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/SkewedRight/vertical.json',
        },
        'transitionDuration': 1000,
    },
    'SkewedDown': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'ChevronRight': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/ChevronRight/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/ChevronRight/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/ChevronRight/vertical.json',
        },
        'transitionDuration': 1000,
    },
    'ChevronDown': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/ChevronDown/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/ChevronDown/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/ChevronDown/vertical.json',
        },
        'transitionDuration': 1000,
    },
    'RectangleOpenHorizontal': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleOpenHorizontal/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleOpenHorizontal/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleOpenHorizontal/vertical.json',
        },
        'transitionDuration': 1000,
    },
    'RectangleOpenVertical': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'RectangleRight': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleRight/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleRight/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleRight/vertical.json',
        },
        'transitionDuration': 1000,
    },
    'RectangleDown': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleDown/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleDown/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/RectangleDown/vertical.json',
        },
        'transitionDuration': 1000,
    },
    'Diagonal slide': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'GfK Diagonal slide': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/GfKDiagonalSlide/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/GfKDiagonalSlide/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/GfKDiagonalSlide/vertical.json',
        },
        'transitionDuration': 915,
    },
    'Diamond': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
    'Square': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Square/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Square/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Square/vertical.json',
        },
        'transitionDuration': 200,
    },
    'Transparent': {
        'transitionUrl': {
            'landscape': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Transparent/landscape.json',
            'square': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Transparent/square.json',
            'vertical': 'https://storage.googleapis.com/lumen5-prod-lottie/transitions/existing-transitions/Transparent/vertical.json',
        },
        'transitionDuration': 1000,
    },
    'None': {
        'transitionUrl': {
            'landscape': null,
            'square': null,
            'vertical': null,
        },
        'transitionDuration': 0,
    },
};
